import React from "react";
import { Text } from "@noom/wax-component-library";

import { NoomAcknowledgementIntakePage } from "../components/NoomAcknowledgementIntakePage";
import { MixpanelTypes } from "../common/types";

export const CompoundFormulationChangePage: React.FC = () => (
  <NoomAcknowledgementIntakePage
    title="Important Notice: Your Semaglutide Compound Formulation is Changing"
    intakeType="COMPOUND_FORMULATION_CHANGE"
    mixpanelEventName={MixpanelTypes.CompoundFormulationChangeConfirmed}
    errorTestId="compound-formulation-change-error"
    confirmButtonLabel="I understand, continue"
  >
    <Text size="md" fontWeight="400" marginTop="16px" display="block">
      The pharmacy that dispenses your compounded semaglutide is updating the
      formulation. Please read the following information carefully.
    </Text>

    <Text size="md" fontWeight="700" marginTop="16px" display="block">
      What is Changing:
    </Text>
    <Text size="md" fontWeight="400" marginTop="8px" display="block">
      <strong>Compound Additive</strong> – Your compounded semaglutide
      formulation may be changing in one of the following ways: removal of an
      additive or addition of glycine as an additive. Please note, glycine may
      still be included in the formulation as an inactive ingredient.
    </Text>

    <Text size="md" fontWeight="700" marginTop="16px" display="block">
      What You Should Do:
    </Text>
    <Text size="md" fontWeight="400" marginTop="8px" display="block">
      If your doctor prescribes the new medication, they will send an updated
      treatment plan, please review this carefully. The dose and how you
      administer the medication will remain the same. We are committed to
      making this transition as smooth as possible.
    </Text>

    <Text size="md" fontWeight="700" marginTop="16px" display="block">
      Have Questions?
    </Text>
    <Text size="md" fontWeight="400" marginTop="8px" display="block">
      If you have any questions or concerns, please reach out to your care
      coordinator through in-app messaging and we will be happy to assist you.
    </Text>
  </NoomAcknowledgementIntakePage>
);
